module.exports = __webpack_public_path__ + "static/media/default-placeholder.f065b10c.png";